module.exports = ".auto-exporter-card {\r\n    margin: 10px auto;\r\n}\r\n.auto-spinner {\r\n    margin-left: 10px;\r\n    margin-bottom: 20px; \r\n}\r\n.exporter-mat-card-title  {\r\n    font-size: 22px;\r\n    margin-left: -10px;\r\n    margin-top: 10px; \r\n    margin-bottom: 30px; \r\n}\r\n.exporter-result-heading{\r\n    font-size: 18px;\r\n    font-weight: 450;\r\n    margin-left: -10px;\r\n}\r\n.root-storage-input{\r\n    min-width: 300px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/exporter-hsbshare/exporter-hsbshare.component.css
// module id = ./src/app/exporter-hsbshare/exporter-hsbshare.component.css
// module chunks = main